import { absolutePath } from "../absolutePath";

export const accessGroups = {
  show: (id: number) => absolutePath(`access_registry/access_groups/${id}`),
};
